// project-imports
import ThemeCustm from './themeCustimized';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

const Theme = (presetColor, mode) => {
  return ThemeCustm(mode);
};

export default Theme;
